import { canView } from '@/libs/acl/routeProtection'

export default function useEntityHelper() {
  const getAlt = (prop, data, lang) => (data[prop] && data[prop][lang] && typeof data[prop][lang] === 'object' && data[prop][lang].alt && typeof data[prop][lang].alt === 'object' ? data[prop][lang].alt[lang] : '')

  const createTagIdArray = (oldArray, newArray) => {
    if (!oldArray) {
      return []
    }
    let tagIds = oldArray.filter(item => item && item._id)
    tagIds = tagIds.map(item => item._id)
    if (newArray.length) {
      return [...new Set([...tagIds, ...newArray])]
    }
    return [...new Set([...tagIds])]
  }

  const isViewable = (action, resource) => canView(action, resource)

  return { getAlt, createTagIdArray, isViewable }
}
